(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-strength-bars"] && !Shopify.designMode) return;
  try {
    class ProductStrengthBars extends HTMLElement {
    #metafields = {};

    connectedCallback() {
      this.#parseMetafields();
      this.#checkIfEmpty();
      this.#renderBars();
    }

    #parseMetafields() {
      try {
        const metafieldsAttr = this.dataset.metafields;
        this.#metafields = metafieldsAttr ? JSON.parse(metafieldsAttr) : {};
      } catch (error) {
        console.error('Error parsing metafields:', error);
        this.#metafields = {};
      }
    }

    #checkIfEmpty() {
      const allZero = 
        !this.#metafields.daytime_day &&
      !this.#metafields.daytime_night &&
        !this.#metafields.winter_strength;

      if (allZero) {
        this.classList.add('empty');
      }
    }

    #renderBars() {
      this.#renderDaytimeBar();
      this.#renderSeasonBars();
    }

    #renderDaytimeBar() {
      const dayValue = Math.max(0, Math.min(100, this.#metafields.daytime_day || 0));
      const nightValue = Math.max(0, Math.min(100, this.#metafields.daytime_night || 0));

      const dayFill = this.querySelector('.scentra-day-fill');
      const nightFill = this.querySelector('.scentra-night-fill');

      if (dayFill) {
        dayFill.style.width = `${dayValue}%`;
      }

      if (nightFill) {
        nightFill.style.width = `${nightValue}%`;
      }
    }

    #renderSeasonBars() {
      const seasonMap = {
        'spring': 'spring_strength',
        'summer': 'summer_strength',
        'autumn': 'autumn_strength',
        'winter': 'winter_strength'
      };

      Object.entries(seasonMap).forEach(([season, key]) => {
        const value = Math.max(0, Math.min(100, this.#metafields[key] || 0));
        const fill = this.querySelector(`.scentra-season-fill[data-season="${season}"]`);
        
        if (fill) {
          fill.style.width = `${value}%`;
        }
      });
    }
  }

  customElements.define('product-strength-bars', ProductStrengthBars);
  } catch(e) { console.error(e); }
})();

})();
